import { Controller } from "@hotwired/stimulus"
import { browserTimeZone } from "../helpers/time_zones"

// «Определить автоматически» next to the time zone select.
export default class extends Controller {
  static targets = ["select", "status"]
  static values = { found: String, missing: String }

  detect() {
    const zone = browserTimeZone()
    if (!zone || !this.hasSelectTarget) {
      this.say(this.missingValue)
      return
    }
    let option = Array.from(this.selectTarget.options).find((row) => row.value === zone)
    if (!option) {
      option = new Option(zone, zone)
      this.selectTarget.add(option)
    }
    this.selectTarget.value = zone
    this.say(this.foundValue.replace("__ZONE__", option.textContent))
  }

  say(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message || ""
  }
}
